import {
    CLEAR_ERRORS,
    GET_EMPLOYEE_TRANSACTIONS,
    GET_EMPLOYEES_TRANSACTIONS,
    SET_LOADING,
    UNSET_LOADING,
    UPDATE_TRANSACTION_SUCCESS
} from '../actions/types';

const initialState = {
    dates: [],
    employees: [],
    loading: false,
    numberOfPages: 1,
    total_employees: null,
    error: null,
};

// eslint-disable-next-line

export default function (state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true,
            }
        case UNSET_LOADING:
            return {
                ...state,
                loading: false,
            }


        case UPDATE_TRANSACTION_SUCCESS:
            return {
                ...state,
                update_transaction_id: true,
                error: null,
                loading: false,
            };

        case GET_EMPLOYEES_TRANSACTIONS:

            const {dates, employees} = payload;
            return {
                ...state,
                dates: dates,
                employees: employees.data,
                numberOfPages: employees.last_page,
                current_page: employees.current_page,
                employees_data: payload,
                error: null,
                loading: false,
            };

        case GET_EMPLOYEE_TRANSACTIONS:
            const {id} = payload;

            return {
                ...state,
                employees: state.employees.map(item => item.id == id ? payload : item),
                loading: false,
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                loading: false,
            };

        default:
            return state;
    }
}
